(function () {
  'use strict';

  angular.module('sempraWebapp').service('webSocketService', webSocketService);

  /** @ngInject */
  function webSocketService(
    $log,
    webSocketActions,
    $timeout,
    api,
    jwtHelper,
    sessionData,
    mqttBrokerIp,
    mqttBrokerPort,
    useMqttBrokerSsl,
    checkUserRole
  ) {
    var that = this,
      isInitialized = false,
      webSocket = {},
      ip = '',
      port = 0,
      isConnected = false,
      isSuspended = false,
      reconnectAttempt = 0,
      subscriptionTopics = [],
      options = {
        timeout: 10,
        onSuccess: onConnectSuccess,
        onFailure: onConnectFail,
        useSSL: true
      },
      MESSAGES = {
        BROKER_CLIENT_ID_PREFIX: 'SempraWebApp_',
        MSG_CONNECTION_CONNECTION_ESTABLISHED: 'Connected to WebSocket',
        MSG_CONNECTION_CONNECTION_LOST: 'Connection lost ',
        MSG_CONNECTION_CONNECTION_ERROR: 'Error connecting to websocket',
        MSG_CONNECTION_RECONNECTING: 'Reconnecting to WebSocket...',
        MSG_CONNECTION_MESSAGE_ARRIVED: 'Updating topic ',
        MSG_SUBSCRIBED_TO_TOPIC: 'Subscribed to ',
        MSG_UNSUBSCRIBED_FROM_TOPIC: 'Unsubscribed from '
      };

    var TOPICS = Object.freeze({
      DEVICE: '',
      FEEDS: '/FEED',
      ACTUATORS: '/ACTUATOR',
      MESSAGES: '/MESSAGE',
      FINANCES: '/FINANCES',
      EVENT: '/EVENT',
      NOTICE: 'NOTICE'
    });

    this.TOPICS = TOPICS;

    this.initWebSockets = function () {
      if (!isInitialized && checkUserRole.userRoleExist()) {
        api.getWebSocketsToken().then(
          function (response) {
            // Set topic list to local storage from token
            var decodedToken = jwtHelper.decodeToken(response.websocketToken);
            sessionData.setValue(
              sessionData.Keys.TOPICS_LIST,
              decodedToken.topics
            );
            ip = mqttBrokerIp ? mqttBrokerIp : ip;
            port = mqttBrokerPort ? mqttBrokerPort : port;
            options.useSSL = useMqttBrokerSsl ? useMqttBrokerSsl : options.useSSL;
            webSocket.socket = new Paho.MQTT.Client(
              ip,
              port,
              getMqttBrokerClientId()
            );
            webSocket.socket.onConnectionLost = onConnectFail;
            webSocket.socket.onMessageArrived = onMessageArrived;
            webSocket.socket.connect({
              timeout: options.timeout,
              onSuccess: onConnectSuccess,
              onFailure: onConnectFail,
              reconnect: true,
              useSSL: options.useSSL,
              userName: response.websocketToken,
              password: '12345'
            });
          },
          function () {
            onConnectFail();
          }
        );
      }
    };

    this.unsubscribeSocket = function () {
      reconnectAttempt = 10;
      if (webSocket.socket) {
        subscriptionTopics.forEach(function (topic) {
          webSocket.socket.unsubscribe(topic);
          $log.info(MESSAGES.MSG_UNSUBSCRIBED_FROM_TOPIC + topic);
        });
        subscriptionTopics = [];
      }
      $log.info('Socket unsubscribed');
    };

    this.disconnectSockets = function () {
      webSocket.socket.disconnect();
      webSocket.socket = null;
      webSocket = {};
      isInitialized = false;
      isConnected = false;
      $log.info('Socket disconnected');
    };

    this.suspendMessages = function (suspended) {
      isSuspended = suspended;
    };

    this.isSuspended = function () {
      return isSuspended;
    };

    this.isConnected = function () {
      return isConnected;
    };

    this.subscribeToTopic = function (deviceSerialArray, topicEnumValue) {
      if (isConnected) {
        if (deviceSerialArray) {
          deviceSerialArray.forEach(function (deviceSerial) {
            var topic = deviceSerial + topicEnumValue;
            webSocket.socket.subscribe(topic, { qos: 1 });
            subscriptionTopics.push(topic);
            $log.info(MESSAGES.MSG_SUBSCRIBED_TO_TOPIC + topic);
          });
        }
      }
    };

    this.subscribeToNoticeTopic = function (topicEnumValue) {
      if (isConnected) {
        webSocket.socket.subscribe(topicEnumValue, { qos: 1 });
        subscriptionTopics.push(topicEnumValue);
        $log.info(MESSAGES.MSG_SUBSCRIBED_TO_TOPIC + topicEnumValue);
      }
    };

    this.subscribeToDeviceChanges = function (deviceSerialArray) {
      this.subscribeToTopic(deviceSerialArray, TOPICS.DEVICE);
    };

    this.subscribeToFinanceChanges = function (deviceSerialArray) {
      this.subscribeToTopic(deviceSerialArray, TOPICS.FINANCES);
    };

    this.subscribeToMessageChanges = function (deviceSerialArray) {
      this.subscribeToTopic(deviceSerialArray, TOPICS.MESSAGES);
    };

    this.subscribeToActuatorChanges = function (deviceSerialArray) {
      this.subscribeToTopic(deviceSerialArray, TOPICS.ACTUATORS);
    };

    this.subscribeToFeedChanges = function (deviceSerialArray) {
      this.subscribeToTopic(deviceSerialArray, TOPICS.FEEDS);
    };

    this.subscribeToEventChanges = function (deviceSerialArray) {
      this.subscribeToTopic(deviceSerialArray, TOPICS.EVENT);
    };

    this.subscribeToNoticeChanges = function () {
      this.subscribeToNoticeTopic(TOPICS.NOTICE);
    };

    function getMqttBrokerClientId() {
      var uniquePart = (Date.now().toString(36) + getRandomIdPart()).slice(0, 10);
      return MESSAGES.BROKER_CLIENT_ID_PREFIX + uniquePart;
    }

    function getRandomIdPart() {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID().replace(/-/g, '');
      }

      if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
        var cryptoBuffer = new Uint32Array(2);
        window.crypto.getRandomValues(cryptoBuffer);
        return cryptoBuffer[0].toString(36) + cryptoBuffer[1].toString(36);
      }

      return (
        Math.random().toString(36).slice(2) +
        Math.random().toString(36).slice(2)
      );
    }

    function onConnectSuccess() {
      isInitialized = true;
      isConnected = true;
      reconnectAttempt = 0;
      webSocketActions.notifyConnectionChange(true);
      $log.info(MESSAGES.MSG_CONNECTION_CONNECTION_ESTABLISHED);
    }

    function onConnectFail() {
      isConnected = false;
      isInitialized = false;
      $log.error(MESSAGES.MSG_CONNECTION_CONNECTION_LOST);
      if (reconnectAttempt < 6) {
        $timeout(reconnect, 10000);
      } else {
        webSocketActions.notifyConnectionChange(false);
      }
    }

    function onMessageArrived(message) {
      if (!isSuspended) {
        $log.info(
          MESSAGES.MSG_CONNECTION_MESSAGE_ARRIVED + message.payloadString
        );
        if (message.destinationName.indexOf(TOPICS.FEEDS) >= 0) {
          webSocketActions.notifyDeviceFeedChange(
            getPayload(message.payloadString)
          );
        } else if (message.destinationName.indexOf(TOPICS.ACTUATORS) >= 0) {
          webSocketActions.notifyDeviceActuatorChange(
            getPayload(message.payloadString)
          );
        } else if (message.destinationName.indexOf(TOPICS.MESSAGES) >= 0) {
          webSocketActions.notifyMessagesChange(
            getPayload(message.payloadString)
          );
        } else if (message.destinationName.indexOf(TOPICS.FINANCES) >= 0) {
          webSocketActions.notifyFinancesChange(
            getPayload(message.payloadString)
          );
        } else if (message.destinationName.indexOf(TOPICS.NOTICE) >= 0) {
          webSocketActions.notifyNoticeChange(
            getPayload(message.payloadString)
          );
        } else if (message.destinationName.indexOf(TOPICS.EVENT) >= 0) {
          webSocketActions.notifyDeviceEventChange(
            getPayload(message.payloadString)
          );
        } else {
          webSocketActions.notifyDeviceChange(
            getPayload(message.payloadString)
          );
        }
      }
    }

    function getPayload(message) {
      /* eslint-disable */
      var messageJson = JSON.parse(message);
      /* eslint-enable */
      return messageJson;
    }

    function reconnect() {
      if (!isConnected) {
        $log.info(MESSAGES.MSG_CONNECTION_RECONNECTING);
        reconnectAttempt++;
        that.initWebSockets();
      }
    }
  }
})();
